<template>
  <div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <v-container>
        <v-form ref="form">
          <v-row class="mb-2">
                      <div class="pt-4 pb-4 pl-6">
                          <v-btn 
                              color="warning" 
                              style="width: 100px" 
                              @click="backHandler"> 
                              {{$t('button.back')}}
                          </v-btn>
                      </div>
                  </v-row>
          <div class="wizard-title-card mb-4">
            <div class="wizard-title-header">
              <div class="wizard-title-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
                </svg>
              </div>
              <h2 class="wizard-name" style="color:#ffffff !important;">{{this.wizardcodename}}</h2>
            </div>
            <div class="wizard-title-body">
              <p class="wizard-desc">{{this.wizarddescname}}</p>
            </div>
          </div>
  
           <v-stepper v-model="e1">
             <v-stepper-header>
               <template v-for ="item in wizardStep" >
                 <v-stepper-step
                 :key="item.seqno"
                 :complete ="e1>item"
                 :step="item.seqno"
                 :key-item= "seqno"
                 editable
                 >
                 {{$t('reporwizardlisting.step')}} {{item.seqno}}
                 </v-stepper-step>
  
                <v-divider
                v-if ="item.seqno !== steps"
                :key ="item.seqno"
                ></v-divider>
               </template>
             </v-stepper-header>
  
             <v-stepper-items>
               <v-stepper-content
               v-for="item in wizardStep"
               :key="item.seqno"
               :step="item.seqno"
               > 
               <br/>
               <br/>
                    <v-row
                      style="font-size:13px"
                      align="start"
                      class="mx-0 pb-6"
                      height="200px" >
                        {{item.taskdesc}} 
  
                    </v-row> 
                         
               <br/>
  
                    <v-row
                    style="font-size:0.85rem; font-weight:600; color:#4F6BFF; cursor:pointer; text-decoration:underline; text-underline-offset:2px;"
                      align="start"
                      class="mx-0 pb-3"
                      height="200px"
                          v-on:click ="loadDetailHandlerLink(item.link)"> {{item.funcname}}
                    </v-row>
  
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>

            <div class="wizard-btn-bar mt-4">
              <v-btn class="fbtn fbtn-secondary" @click="prevStep()">
                <v-icon size="16" class="mr-1">mdi-arrow-left</v-icon>
                {{$t('button.previous')}}
              </v-btn>
              <v-btn class="fbtn fbtn-success" @click="nextStep()">
                <v-icon size="16" class="mr-1">mdi-arrow-right</v-icon>
                {{$t('button.next')}}
              </v-btn>
              <v-btn class="fbtn fbtn-cancel ml-auto" @click="resetStep()">
                <v-icon size="16" class="mr-1">mdi-refresh</v-icon>
                {{$t('button.reset')}}
              </v-btn>
            </div>      
        </v-form>
      </v-container>
  
      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>
      <div>
        <v-content>
          <name/>
        </v-content>
      </div>
    </div>
  </div>
</template>

<script>
import VStepper from 'vue-stepper-component';
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-error": ErrorDialog,
     "name" : VStepper
  },

  data() {
    return {      
      rules: {
        required: (value) => !!value || "Required.",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },

     e1: 0,
     steps: this.seqno,
     getid: this.$route.params.id,
     wizardcodename: ' ',
     wizarddescname: ' ',
     


       selections: [{
        wizardid: null,
        wizardcode: null,
        wizarddesc: null,
        seqno: null,
        taskdesc: null,
        link: null,
        funcname: null,
        userid: this.$store.getters.userId
       }],

      wizardItems: [],
      dataItems: [],
      wizardStep: [],
      loading: false,
      isErr: false,
      errMsg: "",
    };
  },

  watch:{

         steps(val){
            if (this.e1>val){
               this.e1 = val
               console.log('e1', this.e1)
            }
          },
       },

  methods: {

        errorHandler($event) {
            this.isErr = $event.isErr;
            this.errMsg = $event.errMsg;
        },

        async loadWizardList() {
          if (!this.getid) return;

          this.loading = true;

          try {
            const res = await this.$store.dispatch('get', {
              url: `/wizardsetupd/${this.getid}`,
            });

            this.wizardItems = res.data.rec;
            this.steps = this.wizardItems.length;
            this.wizardcodename = res.data.rec[0].wizardcode;
            this.wizarddescname = res.data.rec[0].wizarddesc;

            this.wizardStep = res.data.rec.map((r) => ({
              seqno: r.seqno,
              taskdesc: r.taskdesc,
              link: r.link,
              funcname: r.funcname,
            }));

          } catch (err) {
            this.isErr = true;
            this.errMsg = err;
            this.$emit('error', { isErr: this.isErr, errMsg: this.errMsg });
          } finally {
            this.loading = false;
          }
        },

        //push to next step
        nextStep() {
          this.e1++;
        },

        //push to previous step
        prevStep() {
          this.e1--;
        },
         //reset to the first step
        resetStep(){
            this.e1 = 1

        },

        loadDetailHandlerLink(link) {
            this.$router.push({name: link});
        },

         backHandler() {
            this.$router.push({name: 'wizardlisting'});
        },

   },

   async  mounted() {
     await this.loadWizardList();
   },
};
</script>

<style scoped>
.wizard-title-card {
  border-radius: 16px;
  border: 1px solid #E8EDF5;
  box-shadow: 0 2px 12px rgba(0,0,0,0.07);
  overflow: hidden;
  background: #fff;
}
.wizard-title-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  background: linear-gradient(135deg, #4F6BFF 0%, #7C3AFF 100%);
}
.wizard-title-icon {
  width: 36px; height: 36px;
  background: rgba(255,255,255,0.2);
  border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
  color: #fff;
}
.wizard-name {
  font-size: 1.1rem;
  font-weight: 700 !important;
  color: #ffffff !important;
  margin: 0;
  letter-spacing: normal;
  text-shadow: 0 1px 3px rgba(0,0,0,0.2);
}
.wizard-title-body {
  padding: 12px 20px;
}
.wizard-desc {
  font-size: 0.85rem;
  color: #546e7a;
  margin: 0;
  letter-spacing: normal;
}
.wizard-btn-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #F8FAFF;
  border-top: 1px solid #E8EDF5;
  border-radius: 0 0 12px 12px;
  padding: 12px 16px;
  margin-bottom: 8px;
}
.fbtn {
  min-width: 110px !important;
  height: 38px !important;
  border-radius: 8px !important;
  font-size: 0.82rem !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.02em !important;
  box-shadow: none !important;
}
.fbtn-success { background: #059669 !important; color: #fff !important; }
.fbtn-success:hover { background: #047857 !important; }
.fbtn-secondary { background: #4F6BFF !important; color: #fff !important; }
.fbtn-secondary:hover { background: #3B55E6 !important; }
.fbtn-cancel { background: #F1F5F9 !important; color: #64748B !important; }
.fbtn-cancel:hover { background: #E2E8F0 !important; color: #334155 !important; }
.ml-auto { margin-left: auto !important; }
</style>